import AggregatController from "csi/action/AggregateController";
import InformationMessageAggregateController from "csi/action/InformationMessageAggregateController";
import declare from "dojo/_base/declare";

const CreateShareDataSheetsAggregateController = declare([AggregatController, InformationMessageAggregateController], {
	/** message to display on top of the Dialog main content */
	messageRes: "SharedDataSheetInfoMessage",
	bShowProgress: true,
});

export = CreateShareDataSheetsAggregateController;